import styled, { css } from 'styled-components';

import { ReactComponent as Arrow } from '../../../../assets/images/blueTheme/chevronArrow.svg';
import { ReactComponent as DoubleArrow } from '../../../../assets/images/blueTheme/chevronDoubleArrow.svg';

export const PageNumbersContainer = styled.div`
  display: flex;
`;

export const PageItem = styled.div<{ $currentPage?: boolean; $clickableElement: boolean }>(
  ({ theme: { spacers, admanColors }, $currentPage, $clickableElement }) => css`
    margin: ${spacers!.spacer01};
    padding: 0 ${spacers!.spacer01} ${spacers!.spacer01} ${spacers!.spacer01};
    height: 20px;
    border-bottom: ${$currentPage ? `2px solid ${admanColors!.blue.dark.bg1[0]}` : 'none'};
    cursor: ${$clickableElement ? `pointer` : 'inherit'};
    font-size: 12px;
    line-height: 14px;
  `
);

export const DoubleArrowIcon = styled(DoubleArrow)<{ $clickableElement: boolean }>(
  ({ theme: { admanColors }, $clickableElement }) => css`
    cursor: ${$clickableElement ? `pointer` : 'inherit'};

    path {
      fill: ${$clickableElement ? admanColors!.blue.dark.bg1[0] : admanColors!.gray.light.bg3[1]};
    }

    height: 8px;
    width: 11px;
  `
);

export const LeftArrowIcon = styled(Arrow)<{ $clickableElement: boolean }>(
  ({ theme: { admanColors }, $clickableElement }) => css`
    cursor: ${$clickableElement ? `pointer` : 'inherit'};

    path {
      fill: ${$clickableElement ? admanColors!.blue.dark.bg1[0] : admanColors!.gray.light.bg3[1]};
    }

    height: 13px;
    width: 7px;
  `
);

export const DoubleArrowIconRotated = styled(DoubleArrowIcon)`
  transform: rotate(180deg);
`;

export const LeftArrowIconRotated = styled(LeftArrowIcon)`
  transform: rotate(180deg);
`;
